/* istanbul ignore file */
import React from 'react';
import { LinkButton, LinkButtonProps } from 'framework/ui/ui-builder';
import { useContractsUrl } from 'domain/people/contracts/contractsRouting';

const ViewContractButton = (props: Omit<LinkButtonProps, 'children' | 'url'>) => {
  const { getSingleEntityUrl } = useContractsUrl();

  return (
    <LinkButton {...props} url={id => getSingleEntityUrl(id)} key="view-contract">
      View
    </LinkButton>
  );
};

export default ViewContractButton;
